import * as React from 'react'
import Skeleton from '@mui/material/Skeleton'
import { Box, Divider, List, ListItem } from '@mui/material'

const listSkeleton: React.FC<{ items: number }> = ({ items }) => {
  const list = []

  for (let index = 0; index < items; index++) {
    list.push(
      <Box key={index}>
        <Divider />
        <ListItem>
          <Skeleton sx={{ width: '100%', my: 1 }} />
        </ListItem>
      </Box>
    )
  }

  return (
    <List sx={{ px: 2 }}>
      {list}
      <Divider />
    </List>
  )
}

export default listSkeleton
